﻿import { IgnoreChanges } from '../decorators/change-tracker';
import { Enumerable } from '../decorators/enumerable';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eFeatureCenter } from '../enums';
import { IMoveVerticesFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { eMeshChangeTypes, Feature } from './feature';

@Kb3dModel({
    token: Token.MoveVerticesFeature,
})
export class MoveVerticesFeature extends Feature implements IMoveVerticesFeature {
    static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affectedBy = new Set([eMeshChangeTypes.VertexPositions]);
    static _affects = new Set([eMeshChangeTypes.VertexPositions]);

    translation: KbVector;
    rotationAngle: number;
    rotationAxis: KbVector;
    scale: KbVector;
    center: eFeatureCenter;
    _previewParticleSize = 0.005;

    @IgnoreChanges
    private _vertexIndices: number[];
    @Enumerable()
    public get vertexIndices(): number[] {
        if (!this._vertexIndices) this._vertexIndices = [];
        return this._vertexIndices;
    }
    public set vertexIndices(val) {
        this._vertexIndices = val;
    }
}
